import { render, staticRenderFns } from "./QuotationsTable.vue?vue&type=template&id=794f9557&scoped=true&"
import script from "./QuotationsTable.vue?vue&type=script&lang=js&"
export * from "./QuotationsTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsTable.vue?vue&type=style&index=0&id=794f9557&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f9557",
  null
  
)

export default component.exports